module.exports = {"message":"hello i18n !!","cutLocalImage":"ローカル画像を切り取る","choseImage":"画像を选択","showAfterProcess":"切り取った後はこちらに表示されます","downloadNewImage":"ダウンロード画像","submit":"確定","reset":"リセット","trunLeft":"左に曲がる","trunRight":"右に曲がる","cancel":"取り消す","mainTitle":"オンラインで画像を切り取り&回転させる","txtDescription":"このツールを使用して、画像を切り取るか、画像を回転させることができます"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/ja.json
// module id = 1ccB
// module chunks = 1